














































































import { defineComponent, onMounted, ref } from '@vue/composition-api';
import { TextDraft } from '@oare/types';
import moment from 'moment';
import sl from '@/serviceLocator';
import DraftDiffPopup from '@/views/Admin/Drafts/DraftDiffPopup.vue';

export default defineComponent({
  name: 'DashboardDrafts',
  components: {
    DraftDiffPopup,
  },
  setup() {
    const draftsLoading = ref(false);
    const drafts = ref<TextDraft[]>([]);
    const selectedDrafts = ref<TextDraft[]>([]);
    const confirmDeleteDialog = ref(false);
    const deleteDraftsLoading = ref(false);
    const viewingDraft = ref<TextDraft | null>(null);
    const diffDialog = ref(false);

    const actions = sl.get('globalActions');
    const server = sl.get('serverProxy');
    const store = sl.get('store');

    const dateFormat = (dateStr: string) => {
      return moment(dateStr).format('MMMM D, YYYY h:mm a');
    };

    const headers = [
      {
        text: 'Text',
        value: 'textName',
      },
      {
        text: 'Last Updated',
        value: 'updatedAt',
      },
      {
        text: 'Content',
        value: 'content',
      },
    ];

    onMounted(async () => {
      draftsLoading.value = true;
      try {
        const userUuid = store.getters.user ? store.getters.user.uuid : null;

        if (userUuid) {
          drafts.value = await server.getDrafts(userUuid);
        } else {
          actions.showErrorSnackbar('You are not logged in');
        }
      } catch (error) {
        actions.showErrorSnackbar(
          'Error loading drafts. Please try again.',
          error as Error
        );
      } finally {
        draftsLoading.value = false;
      }
    });

    const openDiffDialog = (draft: TextDraft) => {
      viewingDraft.value = { ...draft };
      diffDialog.value = true;
    };

    const deleteDrafts = async () => {
      try {
        deleteDraftsLoading.value = true;
        await Promise.all(
          selectedDrafts.value.map(({ uuid }) => server.deleteDraft(uuid))
        );

        drafts.value = [
          ...drafts.value.filter(
            ({ uuid }) =>
              !selectedDrafts.value.map(({ uuid }) => uuid).includes(uuid)
          ),
        ];
        selectedDrafts.value = [];
        actions.showSnackbar('Drafts successfully deleted');
      } catch (err) {
        actions.showErrorSnackbar('Failed to delete drafts', err as Error);
      } finally {
        deleteDraftsLoading.value = false;
        confirmDeleteDialog.value = false;
      }
    };

    return {
      draftsLoading,
      drafts,
      dateFormat,
      headers,
      viewingDraft,
      diffDialog,
      openDiffDialog,
      selectedDrafts,
      confirmDeleteDialog,
      deleteDrafts,
      deleteDraftsLoading,
    };
  },
});
